export default "__VITE_ASSET__BBSmOnMZ__"